// extracted by mini-css-extract-plugin
module.exports = {"createProjectForm":"_5762f2ac","submitNewProject":"_ce3a3a96","clearIcon":"_5f366879","createNewProjectCta":"_edf04510","explanation":"_778f9e78"};